import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 1 }

import { IFormStep, ISitecoreFormGenericInput } from '@/interfaces';
import { computed } from 'vue';
import { FormInputTypes } from '@/enums/form-input-types.enum';
import useFormInputData, { getAdobeTargetDataAttributes } from '@/composables/useFormInputData';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import DateInput from '@/components/DateInput/DateInput.vue';
import TitleNameInput from '@/components/TitleNameInput/TitleNameInput.vue';
import RACQFormKit from '@/components/RACQFormKit/RACQFormKit.vue';
import Gender from '@/components/Gender/Gender.vue';
import Disclaimer from '@/components/Disclaimer/Disclaimer.vue';
import CallToActionCard from '@/components/CallToActionCard/CallToActionCard.vue';
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import DatePicker from '@/components/DatePicker/DatePicker.vue';
import AccountLoginInfoBox from '@/components/AccountLoginInfoBox/AccountLoginInfoBox.vue';
import PhoneNumberInput from '@/components/PhoneNumberInput/PhoneNumberInput.vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import RadioCardList from '@/components/RadioCardList/RadioCardList.vue';
import RangeInput from '@/components/RangeInput/RangeInput.vue';
import DateOfBirth from '@/components/DateInput/DateOfBirth.vue';
import Divider from '@/components/Divider/Divider.vue';
import LinkPanel from '@/components/LinkPanel/LinkPanel.vue';
import PromoCardMiniList from '@/components/PromoCardMini/PromoCardMiniList.vue';
import PromoCardBasicList from '@/components/PromoCardBasic/PromoCardBasicList.vue';
import { FormKit } from '@formkit/vue';
import TextArea from '../TextArea/TextArea.vue';
import CTABanner from '../CTABanner/CTABanner.vue';

// Define Vue props
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'FormStepInputs',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;

const { formInputData, convertSitecoreToVueCheckboxListOptions } = useFormInputData(props.step.formInputs!);
const inputs = computed<ISitecoreFormGenericInput[]>(() =>
  props.step?.formInputs ? Object.values(props.step?.formInputs).filter((input) => !input?.isHidden) : []
);

const getRacqFormKitBindings = (input: any) => {
  if (input.inputType?.value == FormInputTypes.CHECKBOX && input.fields.length > 0) {
    return {
      ...formInputData(input.formInputId?.value),
      options: convertSitecoreToVueCheckboxListOptions(input),
    };
  } else {
    return formInputData(input.formInputId?.value);
  }
};

function adobeTargetDataTypes(input: Record<string, any>) {
  return getAdobeTargetDataAttributes(input, props.step.stepName!);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputs.value as Record<string, any>[], (input) => {
    return (_openBlock(), _createElementBlock("div", _mergeProps({
      key: input.formInputId?.value + input.label?.value,
      ref_for: true
    }, adobeTargetDataTypes(input), { class: "empty:hidden" }), [
      _renderSlot(_ctx.$slots, input.formInputId?.value ?? input.name, {}, () => [
        (input.inputType?.value == _unref(FormInputTypes).ADDRESS_AUTOCOMPLETE)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" [Please use AddressLookupOptions component] ")
            ], 64))
          : (input.inputType?.value == _unref(FormInputTypes).DOB)
            ? (_openBlock(), _createBlock(DateOfBirth, {
                key: 1,
                bindings: _unref(formInputData)(input.formInputId?.value),
                isPolicyholder: input?.isPolicyholder?.value,
                isDriver: input?.isDriver?.value,
                invalidDobWarning: input?.invalidDobWarning?.value,
                maxDateByDays: input?.maxDateByDays?.value,
                minDate: input?.minDate?.value,
                dateMustBefore: input?.dateMustBefore?.value,
                dateMustAfter: input?.dateMustAfter?.value
              }, null, 8, ["bindings", "isPolicyholder", "isDriver", "invalidDobWarning", "maxDateByDays", "minDate", "dateMustBefore", "dateMustAfter"]))
            : (input.inputType?.value == _unref(FormInputTypes).DATE_INPUT)
              ? (_openBlock(), _createBlock(DateInput, {
                  key: 2,
                  bindings: _unref(formInputData)(input.formInputId?.value),
                  minDateToday: input?.minDateToday?.value,
                  maxDateByDays: input?.maxDateByDays?.value,
                  minDate: input?.minDate?.value,
                  dateMustBefore: input?.dateMustBefore?.value,
                  dateMustAfter: input?.dateMustAfter?.value
                }, null, 8, ["bindings", "minDateToday", "maxDateByDays", "minDate", "dateMustBefore", "dateMustAfter"]))
              : (input.inputType?.value == _unref(FormInputTypes).TITLE_NAME)
                ? (_openBlock(), _createBlock(TitleNameInput, {
                    key: 3,
                    bindings: _unref(formInputData)(input.formInputId?.value),
                    firstnameMinLength: input?.firstnameMinLength.value,
                    firstnameMaxLength: input?.firstnameMaxLength.value,
                    lastnameMinLength: input?.lastnameMinLength.value,
                    lastnameMaxLength: input?.lastnameMaxLength.value,
                    titleRequiredMessage: input?.titleRequiredMessage?.value,
                    firstnameRequiredErrorMessage: input?.firstnameRequiredErrorMessage?.value,
                    firstnameRegex: input?.firstnameRegex?.value,
                    firstnameRegexErrorMessage: input?.firstnameRegexErrorMessage?.value,
                    lastnameRequiredErrorMessage: input?.lastnameRequiredErrorMessage?.value,
                    lastnameRegex: input?.lastnameRegex?.value,
                    lastnameRegexErrorMessage: input?.lastnameRegexErrorMessage?.value
                  }, null, 8, ["bindings", "firstnameMinLength", "firstnameMaxLength", "lastnameMinLength", "lastnameMaxLength", "titleRequiredMessage", "firstnameRequiredErrorMessage", "firstnameRegex", "firstnameRegexErrorMessage", "lastnameRequiredErrorMessage", "lastnameRegex", "lastnameRegexErrorMessage"]))
                : (input.inputType?.value == _unref(FormInputTypes).LABEL)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 4,
                      field: input.label,
                      class: _normalizeClass(input.outerClass?.value)
                    }, null, 8, ["field", "class"]))
                  : (input.inputType?.value == _unref(FormInputTypes).GENDER)
                    ? (_openBlock(), _createBlock(Gender, {
                        key: 5,
                        bindings: _unref(formInputData)(input.formInputId?.value)
                      }, null, 8, ["bindings"]))
                    : (input.inputType?.value == _unref(FormInputTypes).CALL_TO_ACTION_CARD)
                      ? (_openBlock(), _createBlock(CallToActionCard, {
                          key: 6,
                          bindings: _unref(formInputData)(input.formInputId?.value)
                        }, null, 8, ["bindings"]))
                      : (input.inputType?.value == _unref(FormInputTypes).DISCLAIMER)
                        ? (_openBlock(), _createBlock(Disclaimer, {
                            key: 7,
                            bindings: input
                          }, null, 8, ["bindings"]))
                        : (input.inputType?.value == _unref(FormInputTypes).SECTION_PANEL)
                          ? (_openBlock(), _createBlock(SectionPanel, _mergeProps({
                              key: 8,
                              ref_for: true
                            }, input), null, 16))
                          : (input.inputType?.value == _unref(FormInputTypes).RADIO_CARD_LIST)
                            ? (_openBlock(), _createBlock(RadioCardList, {
                                key: 9,
                                bindings: _unref(formInputData)(input.formInputId?.value)
                              }, null, 8, ["bindings"]))
                            : (input.inputType?.value == _unref(FormInputTypes).CUSTOM)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [], 64))
                              : (input.inputType?.value == _unref(FormInputTypes).PHONE_NUMBER)
                                ? (_openBlock(), _createBlock(PhoneNumberInput, {
                                    key: 11,
                                    bindings: _unref(formInputData)(input.formInputId?.value)
                                  }, null, 8, ["bindings"]))
                                : (input.inputType?.value == _unref(FormInputTypes).CTABANNER)
                                  ? (_openBlock(), _createBlock(CTABanner, {
                                      key: 12,
                                      fields: {
            title: input?.title,
            subTitle: input?.subTitle,
            icon: input?.icon,
          }
                                    }, null, 8, ["fields"]))
                                  : (input.inputType?.value == _unref(FormInputTypes).DATEPICKER)
                                    ? (_openBlock(), _createBlock(DatePicker, {
                                        key: 13,
                                        bindings: _unref(formInputData)(input.formInputId?.value),
                                        minDateToday: input?.minDateToday?.value,
                                        maxDateByDays: input?.maxDateByDays?.value,
                                        minDateValidationMessage: input?.minDateValidationMessage?.value,
                                        maxDateValidationMessage: input?.maxDateValidationMessage?.value
                                      }, null, 8, ["bindings", "minDateToday", "maxDateByDays", "minDateValidationMessage", "maxDateValidationMessage"]))
                                    : (input.inputType?.value == _unref(FormInputTypes).LOGINBUTTON)
                                      ? (_openBlock(), _createBlock(AccountLoginInfoBox, {
                                          key: 14,
                                          fields: input
                                        }, null, 8, ["fields"]))
                                      : (input.inputType?.value == _unref(FormInputTypes).PANEL_TITLE)
                                        ? (_openBlock(), _createBlock(PanelTitle, {
                                            key: 15,
                                            bindings: _unref(formInputData)(input.formInputId?.value),
                                            title: input.title!,
                                            subTitle: input.subTitle!,
                                            icon: input.icon,
                                            isTextBlock: input.isTextBlock,
                                            panelType: input.panelType
                                          }, null, 8, ["bindings", "title", "subTitle", "icon", "isTextBlock", "panelType"]))
                                        : (input.inputType?.value == _unref(FormInputTypes).CUSTOM_EMAIL_CONFIRMATION)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                                              _createTextVNode(" [Please use SendEmail component] ")
                                            ], 64))
                                          : (input.inputType?.value == _unref(FormInputTypes).FIND_CAR)
                                            ? (_openBlock(), _createBlock(_unref(FormKit), _mergeProps({
                                                key: 17,
                                                ref_for: true
                                              }, input, { type: "findCar" }), null, 16))
                                            : (input.inputType?.value == _unref(FormInputTypes).SLIDER)
                                              ? (_openBlock(), _createBlock(RangeInput, _mergeProps({
                                                  key: 18,
                                                  ref_for: true
                                                }, input), null, 16))
                                              : (input.inputType?.value == _unref(FormInputTypes).DIVIDER)
                                                ? (_openBlock(), _createBlock(Divider, {
                                                    key: 19,
                                                    outerClass: input.outerClass?.value
                                                  }, null, 8, ["outerClass"]))
                                                : (input.inputType?.value == _unref(FormInputTypes).LINKPANEL)
                                                  ? (_openBlock(), _createBlock(LinkPanel, {
                                                      key: 20,
                                                      bindings: _unref(formInputData)(input.formInputId?.value),
                                                      heading: input.heading,
                                                      headingDescription: input.headingDescription,
                                                      subheading: input.subheading,
                                                      subheadingDescription: input.subheadingDescription,
                                                      links: input.fields,
                                                      isGreyBackground: input.isGreyBackground,
                                                      isArrowLinks: input.isArrowLinks,
                                                      iconSize: input.iconSize,
                                                      globalIcon: input.globalIcon,
                                                      globalButtonLabel: input.globalButtonLabel
                                                    }, null, 8, ["bindings", "heading", "headingDescription", "subheading", "subheadingDescription", "links", "isGreyBackground", "isArrowLinks", "iconSize", "globalIcon", "globalButtonLabel"]))
                                                  : (input.inputType?.value == _unref(FormInputTypes).PROMO_CARD_MINI_LIST)
                                                    ? (_openBlock(), _createBlock(PromoCardMiniList, {
                                                        key: 21,
                                                        bindings: _unref(formInputData)(input.formInputId?.value),
                                                        promoCards: input.fields,
                                                        heading: input.heading,
                                                        cardLayout: input.cardLayout,
                                                        maxItemsToShow: input.maxItemsToShow
                                                      }, null, 8, ["bindings", "promoCards", "heading", "cardLayout", "maxItemsToShow"]))
                                                    : (input.inputType?.value == _unref(FormInputTypes).PROMO_CARD_BASIC_LIST)
                                                      ? (_openBlock(), _createBlock(PromoCardBasicList, {
                                                          key: 22,
                                                          bindings: _unref(formInputData)(input.formInputId?.value),
                                                          promoCards: input.fields,
                                                          heading: input.heading,
                                                          cardLayout: input.cardLayout,
                                                          maxItemsToShow: input.maxItemsToShow
                                                        }, null, 8, ["bindings", "promoCards", "heading", "cardLayout", "maxItemsToShow"]))
                                                      : (input.inputType?.value == _unref(FormInputTypes).TEXTAREA)
                                                        ? (_openBlock(), _createBlock(TextArea, {
                                                            key: 23,
                                                            bindings: _unref(formInputData)(input.formInputId?.value),
                                                            maxContentLength: _unref(formInputData)(input.formInputId?.value).maxlength
                                                          }, null, 8, ["bindings", "maxContentLength"]))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 24 }, [
                                                            (input.inputType?.value)
                                                              ? (_openBlock(), _createBlock(RACQFormKit, {
                                                                  key: 0,
                                                                  bindings: getRacqFormKitBindings(input)
                                                                }, null, 8, ["bindings"]))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_1))
                                                          ], 64))
      ])
    ], 16))
  }), 128))
}
}

})